<template>
    <div ref="container" class="promotion-allocation-area__expansion">
        <promotion-products
            :promotion-id="params.data.promotionId"
            :is-products-disabled="isProductsDisabled"
            :assigned-products="assignedProducts"
        />
    </div>
</template>

<script>
import { nextTick } from 'vue';
import { mapGetters, mapState } from 'vuex';
import { flatMap, keyBy } from 'lodash';

export default {
    name: 'PromotionProductsRowRenderer',
    props: ['params'],
    computed: {
        ...mapState('subCampaigns', ['selectedAreaData']),
        ...mapGetters('subCampaigns', ['selectedResourceDefinition']),
        isProductsDisabled() {
            return this.selectedAreaData
                ? this.selectedAreaData.promotionId !== this.params.data.promotionId
                : true;
        },
        selectedResourceDefinitionAssignmentsMap() {
            if (this.selectedResourceDefinition?.pageCount) {
                const assignmentsArray = flatMap(
                    this.selectedResourceDefinition.pages,
                    page => page.assignment
                );
                return keyBy(assignmentsArray.filter(a => a.promotionId), 'promotionId');
            }
            return {};
        },
        assignedProducts() {
            const assignments = this.selectedResourceDefinitionAssignmentsMap[
                this.params.data.promotionId
            ];
            return assignments ? assignments.products || [] : [];
        },
    },
    async mounted() {
        this.resizeObserver = new ResizeObserver(() => this.updateRowHeight());
        await nextTick();
        // Observe the inner element (promotion-products root) so the observer
        // fires as items render, not when the clipped AG-Grid wrapper changes.
        const inner = this.$refs.container?.firstElementChild;
        if (inner) this.resizeObserver.observe(inner);
    },
    beforeUnmount() {
        this.resizeObserver?.disconnect();
    },
    methods: {
        updateRowHeight() {
            const inner = this.$refs.container?.firstElementChild;
            if (!inner || !this.params?.node || !this.params?.api) return;
            const height = inner.offsetHeight;
            if (height <= 0 || height === this.params.node.rowHeight) return;
            this.params.node.setRowHeight(height);

            requestAnimationFrame(() => {
                if (this.params?.api) {
                    this.params.api.resetRowHeights();
                }
            });
        },
    },
};
</script>
